export default __webpack_public_path__ + "static/media/image-gallery-sugarcubes.09b72f4f.jpg";